export const version = "json-wallets/5.2.0";
